import { Tooltip } from 'antd';
import type { AppTooltipProps } from './Tooltip.types';
import { getOverlayClassNames } from './Tooltip.utils';

export const AppTooltip = (props: AppTooltipProps) => {
  const overlayClassNames = getOverlayClassNames(props);

  return <Tooltip {...props} overlayClassName={overlayClassNames} />;
};
